export default [
  {
    component: 'CNavItem',
    name: 'Start',
    to: '/start',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
      text: 'Admin',
    },
  },
  {
    component: 'CNavItem',
    name: 'Szukaj wózka',
    to: '/jmp/parkMaszynowyAll',
    icon: 'cil-puzzle',
    color: 'color4',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Klienci firmy',
    to: '/jmp/parkMaszynowyKlienci',
    icon: 'cil-group',
    color: 'color2',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Sprzęt na stanie',
    to: '/jmp/parkMaszynowy',
    icon: 'cil-garage',
    color: 'color3',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Sprzęt na wynajmnie',
    to: '/jmp/parkMaszynowyW',
    icon: 'cil-share-alt',
    color: 'color5',
    column: 1
  },
  //{
  //  component: 'CNavItem',
  //  name: 'Wózki sprzedane',
  //  to: '/jmp/parkMaszynowyL',
  //  icon: 'cil-car-alt',
  //  color: 'color6'
  //},
  {
    component: 'CNavGroup',
    name: 'Zlecenia handlowe',
    to: '/base',
    icon: 'cil-basket',
    color: 'color16',
    items: [
      {
        component: 'CNavItem',
        name: 'Sprzedaż',
        longname: 'Zlecenia Sprzedaż',
        to: '/jmp/zleceniaHandloweSprzedaz',
        column: 2,
        longcolor: 'color16',
        longicon: 'cil-basket',
      },
      {
        component: 'CNavItem',
        name: 'Wynajem',
        longname: 'Zlecenia Wynajem',
        to: '/jmp/zleceniaHandloweWynajem',
        column: 2,
        longcolor: 'color16',
        longicon: 'cil-basket',
      },
  //    {
  //      component: 'CNavItem',
  //      name: 'Usługa',
  //      to: '/jmp/zleceniaHandloweUsluga',
  //    },
    ]
  },
  {
    component: 'CNavGroup',
    name: 'Zlecenia napraw',
    to: '/base',
    icon: 'cil-paint-bucket',
    color: 'color6',
    items: [
      {
        component: 'CNavItem',
        name: 'Zgłoszenia',
        longname: 'Naprawy zgłoszenia',
        longicon: 'cil-paint-bucket',
        longcolor: 'color6',
        to: '/jmp/zleceniaWarsztatowe',
        column: 2
      },
      {
        component: 'CNavItem',
        name: 'Mobilne',
        longname: 'Naprawy mobilne',
        longicon: 'cil-paint-bucket',
        longcolor: 'color6',
        to: '/jmp/zleceniaNaprawMobilne',
        column: 2
      },
      {
        component: 'CNavItem',
        name: 'Warsztatowe',
        longname: 'Naprawy warsztatowe',
        longicon: 'cil-paint-bucket',
        longcolor: 'color6',
        to: '/jmp/zleceniaNaprawWarsztatowe',
        column: 2
      },
    ]
  },

  //{
  //  component: 'CNavItem',
  //  name: 'Zlecenia',
  //  to: '/jmp/zleceniaWarsztatowe',
  //  icon: 'cil-task',
  //  color: 'color8'
  //},
  //{
  //  component: 'CNavItem',
  //  name: 'Maszyny w naprawie',
  //  to: '/jmp/wNaprawie',
  //  icon: 'cil-paint-bucket',
  //},
  {
    component: 'CNavItem',
    name: 'Magazyn części',
    to: '/jmp/zleceniaCzesci',
    icon: 'cil-memory',
    color: 'color11',
    column: 3
  },
  {
    component: 'CNavItem',
    name: 'Transport',
    to: '/jmp/transport',
    icon: 'cil-truck',
    color: 'color15',
    column: 3
  },
  {
    component: 'CNavItem',
    name: 'Zadania',
    to: '/jmp/Zadania',
    icon: 'cil-options',
    color: 'color12',
    column: 3
  },
  {
    component: 'CNavItem',
    name: 'Moje zadania',
    to: '/jmp/MojeZadania',
    icon: 'cil-options',
    color: 'color12',
    column: 3
  },
  {
    component: 'CNavGroup',
    name: 'Raporty',
    to: '/base',
    icon: 'cil-print',
    color: 'color8',
    items: [
      {
        component: 'CNavItem',
        name: 'Przeglądy',
        to: '/jmp/raportPrzeglady',
        longname: 'Raport Przeglądy',
        longcolor: 'color8',
        longicon: 'cil-print',
        column: 4
      },
      {
        component: 'CNavItem',
        name: 'Badania',
        to: '/jmp/raportBadania',
        longname: 'Raport Badania',
        longcolor: 'color8',
        longicon: 'cil-print',
        column: 4
      },
      {
        component: 'CNavItem',
        name: 'Wynajem',
        to: '/jmp/raportWynajem',
        longname: 'Raport Wynajem',
        longcolor: 'color8',
        longicon: 'cil-print',
        column: 4
      },
      {
        component: 'CNavItem',
        name: 'Historia wynajmów',
        longname: 'Raport Historia Wynajmów',
        longcolor: 'color8',
        longicon: 'cil-print',
        to: '/jmp/araportWynajemAll',
        column: 4
      },
    ]
  },
{
    component: 'CNavGroup',
    name: 'Księgowość',
    to: '/base',
    icon: 'cil-money',
    color: 'color7',
    items: [
    {
    component: 'CNavItem',
    name: 'Do wystawienia',
    longname: 'Dok. księgowe do wystawienia',
    longcolor: 'color7',
    longicon: 'cil-money',
    to: '/jmp/Ksiegowosc',
    column: 3
  },
  {
    component: 'CNavItem',
    name: 'Fv wystawione',
    longname: 'Dok. księgowe wystawione',
    longcolor: 'color7',
    longicon: 'cil-money',
    to: '/jmp/Ksiegowosc',
    column: 3
  }
]
},
  /*
  {
    component: 'CNavTitle',
    name: 'Serwis',
  },
  {
    component: 'CNavItem',
    name: 'Nowa naprawa',
    to: '/jmp/service',
    icon: 'cil-cog',
  },
  {
    component: 'CNavItem',
    name: 'Serwis mobilny',
    to: '/jmp/zleceniaSerwisowe',
    icon: 'cil-cloudy',
  },
  {
    component: 'CNavItem',
    name: 'Historia',
    to: '/dev/working',
    icon: 'cil-history',
  },
  {
    component: 'CNavTitle',
    name: 'Wynajem',
  },
  {
    component: 'CNavItem',
    name: 'Nowy wpis',
    to: '/dev/working',
    icon: 'cil-external-link',
  },
  //{
  //  component: 'CNavItem',
  //  name: 'Historia',
  //  to: '/dev/working',
  //  icon: 'cil-history',
  //},
  {
    component: 'CNavTitle',
    name: 'Magazyn',
  },
  {
    component: 'CNavItem',
    name: 'Lista części',
    to: '/dev/working',
    icon: 'cil-memory',
  },
  {
    component: 'CNavTitle',
    name: 'Sprzedaż',
  },
  
  {
    component: 'CNavItem',
    name: 'Dostawa',
    to: '/dev/working',
    icon: 'cil-industry',
  },
  */

  {
    component: 'CNavTitle',
    name: 'Konfiguracja',
  },
  {
    component: 'CNavItem',
    name: 'Zmień hasło',
    to: '/jmp/changePassword',
    icon: 'cil-shield-alt',
  },
  {
    component: 'CNavItem',
    name: 'Użytkownicy',
    to: '/jmp/users',
    icon: 'cil-user-plus',
  },
  {
    component: 'CNavItem',
    name: 'Listy kontrolne',
    to: '/jmp/listaCzynnosci',
    icon: 'cil-task',
  }
  ,
  {
    component: 'CNavItem',
    name: 'Szablony mailowe',
    to: '/jmp/szablony',
    icon: 'cib-gmail',
  }
  /*,
  {
    component: 'CNavItem',
    name: 'Colors',
    to: '/theme/colors',
    icon: 'cil-drop',
  },
  {
    component: 'CNavItem',
    name: 'Typography',
    to: '/theme/typography',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavTitle',
    name: 'Components',
  },
  {
    component: 'CNavGroup',
    name: 'Base',
    to: '/base',
    icon: 'cil-puzzle',
    items: [
      {
        component: 'CNavItem',
        name: 'Accordion',
        to: '/base/accordion',
      },
      {
        component: 'CNavItem',
        name: 'Breadcrumbs',
        to: '/base/breadcrumbs',
      },
      {
        component: 'CNavItem',
        name: 'Cards',
        to: '/base/cards',
      },
      {
        component: 'CNavItem',
        name: 'Carousels',
        to: '/base/carousels',
      },
      {
        component: 'CNavItem',
        name: 'Collapses',
        to: '/base/collapses',
      },
      {
        component: 'CNavItem',
        name: 'List Groups',
        to: '/base/list-groups',
      },
      {
        component: 'CNavItem',
        name: 'Navs & Tabs',
        to: '/base/navs',
      },
      {
        component: 'CNavItem',
        name: 'Paginations',
        to: '/base/paginations',
      },
      {
        component: 'CNavItem',
        name: 'Placeholders',
        to: '/base/placeholders',
      },
      {
        component: 'CNavItem',
        name: 'Popovers',
        to: '/base/popovers',
      },
      {
        component: 'CNavItem',
        name: 'Progress',
        to: '/base/progress',
      },
      {
        component: 'CNavItem',
        name: 'Spinners',
        to: '/base/spinners',
      },
      {
        component: 'CNavItem',
        name: 'Tables',
        to: '/base/tables',
      },
      {
        component: 'CNavItem',
        name: 'Tooltips',
        to: '/base/tooltips',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Buttons',
    to: '/buttons',
    icon: 'cil-cursor',
    items: [
      {
        component: 'CNavItem',
        name: 'Buttons',
        to: '/buttons/standard-buttons',
      },
      {
        component: 'CNavItem',
        name: 'Button Groups',
        to: '/buttons/button-groups',
      },
      {
        component: 'CNavItem',
        name: 'Dropdowns',
        to: '/buttons/dropdowns',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Forms',
    to: '/forms',
    icon: 'cil-notes',
    items: [
      {
        component: 'CNavItem',
        name: 'Form Control',
        to: '/forms/form-control',
      },
      {
        component: 'CNavItem',
        name: 'Select',
        to: '/forms/select',
      },
      {
        component: 'CNavItem',
        name: 'Checks & Radios',
        to: '/forms/checks-radios',
      },
      {
        component: 'CNavItem',
        name: 'Range',
        to: '/forms/range',
      },
      {
        component: 'CNavItem',
        name: 'Input Group',
        to: '/forms/input-group',
      },
      {
        component: 'CNavItem',
        name: 'Floating Labels',
        to: '/forms/floating-labels',
      },
      {
        component: 'CNavItem',
        name: 'Layout',
        to: '/forms/layout',
      },
      {
        component: 'CNavItem',
        name: 'Validation',
        to: '/forms/validation',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Charts',
    to: '/charts',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavGroup',
    name: 'Icons',
    to: '/icons',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'CoreUI Icons',
        to: '/icons/coreui-icons',
        badge: {
          color: 'info',
          text: 'NEW',
        },
      },
      {
        component: 'CNavItem',
        name: 'Brands',
        to: '/icons/brands',
      },
      {
        component: 'CNavItem',
        name: 'Flags',
        to: '/icons/flags',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Notifications',
    to: '/notifications',
    icon: 'cil-bell',
    items: [
      {
        component: 'CNavItem',
        name: 'Alerts',
        to: '/notifications/alerts',
      },
      {
        component: 'CNavItem',
        name: 'Badges',
        to: '/notifications/badges',
      },
      {
        component: 'CNavItem',
        name: 'Modals',
        to: '/notifications/modals',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Widgets',
    to: '/widgets',
    icon: 'cil-calculator',
    badge: {
      color: 'primary',
      text: 'NEW',
      shape: 'pill',
    },
  },
  {
    component: 'CNavTitle',
    name: 'Extras',
  },
  {
    component: 'CNavGroup',
    name: 'Pages',
    to: '/pages',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'Login',
        to: '/pages/login',
      },
      {
        component: 'CNavItem',
        name: 'Register',
        to: '/pages/register',
      },
      {
        component: 'CNavItem',
        name: 'Error 404',
        to: '/pages/404',
      },
      {
        component: 'CNavItem',
        name: 'Error 500',
        to: '/pages/500',
      },
    ],
  },*/

  // {
  //   component: 'CNavItem',
  //   name: 'Download CoreUI',
  //   href: 'http://coreui.io/vue/',
  //   icon: { name: 'cil-cloud-download', class: 'text-white' },
  //   _class: 'bg-success text-white',
  //   target: '_blank'
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Try CoreUI PRO',
  //   href: 'http://coreui.io/pro/vue/',
  //   icon: { name: 'cil-layers', class: 'text-white' },
  //   _class: 'bg-danger text-white',
  //   target: '_blank'
  // }
]